import { userConstants, commonConstants, paymentConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { transcationEffect, paymentEffect } from '../_effects';
import { alertActions } from './alertActions';

export const transcationActions = {
  transcationList,
  paymentMode,
  saveRemittance,
  getTransactionSearchByRefno,
  cancelTransaction,
  getDrawingBank,
  setTransactionReceiveCur,
  checkValidId,
  clearPreviousMessage,
  setLastVisitedPage,
  clearTransInfo,
};

function setLastVisitedPage(page) {
  return (dispatch) => {
    dispatch(setLastPage(page));
  };
}

function setLastPage(page) {
  return { type: commonConstants.LAST_PAGE, payload: page };
}

function setTransactionReceiveCur(curr) {
  return (dispatch) => {
    dispatch(receiveCurr(curr));
  };
}
function receiveCurr(curr) {
  return { type: commonConstants.RECEIVED_CURRENCY, curr };
}

function setAmountTransferred(amount) {
  return (dispatch) => {
    dispatch(setNetAmt(amount));
  };
}

function setNetAmt(amount) {
  return { type: paymentConstants.NET_AMT, data: amount };
}

function setTransferRate(rate, charges) {
  return (dispatch) => {
    dispatch(setRate(rate, charges));
  };
}

function setRate(rate, charges) {
  const data = { rate, charges };
  return { type: paymentConstants.TRANSFER_RATE, data: data };
}

function transcationList(transcation) {
  return (dispatch) => {
    dispatch(request(transcation));
    transcationEffect.getRemitHistory(transcation).then(
      (transcation) => {
        if (transcation?.data?.statusCode == 404 && transcation?.data?.message === 'Invalid Session ID') {
          alert('Session is not valid. Please login again');
          localStorage.clear();
          window.location = '/';
        }
        dispatch(success(transcation));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(transcation) {
    return { type: commonConstants.TRANSCATION_REQUEST, transcation };
  }
  function success(transcation) {
    return { type: commonConstants.TRANSCATION_SUCCESS, transcation };
  }
  function failure(error) {
    return { type: commonConstants.TRANSCATION_FAILURE, error };
  }
}

function paymentMode(paymentMode) {
  return (dispatch) => {
    dispatch(request(paymentMode));
    paymentEffect.getPaymentMode(paymentMode).then(
      (paymentMode) => {
        dispatch(success(paymentMode));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(paymentMode) {
    return { type: paymentConstants.GET_PAYMENT_MODE_REQUEST, paymentMode };
  }
  function success(paymentMode) {
    return { type: paymentConstants.GET_PAYMENT_MODE_SUCCESS, paymentMode };
  }
  function failure(error) {
    return { type: paymentConstants.GET_PAYMENT_MODE_FAILURE, error };
  }
}

function checkValidId(details, paymentDetails, baseURL, toCurrency) {
  return (dispatch) => {
    dispatch(requestValidity(details));
    transcationEffect.getValidID(details).then(
      (res) => {
        if (res.data?.statusCode === '200') {
          dispatch(saveRemittance(paymentDetails, baseURL, toCurrency));
        } else {
          dispatch(successValidate(res));
        }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failureValidate(error.toString()));
      }
    );
  };
}

function requestValidity(saveRemit) {
  return { type: paymentConstants.VALID_ID_REQUEST, saveRemit };
}
function successValidate(saveRemit) {
  return { type: paymentConstants.SAVE_REMIT_SUCCESS, saveRemit };
}
function failureValidate(error) {
  return { type: paymentConstants.VALID_ID_FAILURE, error };
}

function setKNetRecCurrency(currency) {
  return (dispatch) => {
    dispatch(setToCurrency(currency));
  };
}

function setToCurrency(currency) {
  return { type: paymentConstants.SAVE_TO_CURRENCY, payload: currency };
}

function saveRemittance(saveRemit, baseURL, toCurrency) {
  return (dispatch) => {
    dispatch(request(saveRemit));
    transcationEffect.saveRemittance(saveRemit).then(
      (res) => {
        dispatch(success(res));
        dispatch(setAmountTransferred(saveRemit?.Data?.NetAmount));
        dispatch(setTransferRate(saveRemit?.Data?.DRate, saveRemit?.Data?.Charges));
        dispatch(clearLoading());
        if (saveRemit.Data.PayMode === 'P' && res.status == 200) {
          dispatch(setKNetRecCurrency(toCurrency));
          window.location.href = `${baseURL}?PUN=${res.data.response.Refno}&ReqMode=WEB`;
        }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function clearLoading() {
    return { type: paymentConstants.CLEAR_LOADING, payload: null };
  }

  function request(saveRemit) {
    return { type: paymentConstants.SAVE_REMIT_REQUEST, saveRemit };
  }
  function success(saveRemit) {
    return { type: paymentConstants.SAVE_REMIT_SUCCESS, saveRemit };
  }
  function failure(error) {
    return { type: paymentConstants.SAVE_REMIT_FAILURE, error };
  }
}

function clearTransInfo() {
  return (dispatch) => {
    dispatch(clearTransDetails());
  };
}

function clearTransDetails() {
  return { type: paymentConstants.CLEAR_TRANS_INFO, payload: null };
}

function getTransactionSearchByRefno(getTranscation) {
  return (dispatch) => {
    dispatch(request(getTranscation));
    transcationEffect.getTransactionRef(getTranscation).then(
      (getTranscation) => {
        dispatch(success(getTranscation));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(getTranscation) {
    return { type: paymentConstants.GET_TRANSACTION_SEARCH_REF_REQUEST, getTranscation };
  }
  function success(getTranscation) {
    return { type: paymentConstants.GET_TRANSACTION_SEARCH_REF_SUCCESS, getTranscation };
  }
  function failure(error) {
    return { type: paymentConstants.GET_TRANSACTION_SEARCH_REF_FAILURE, error };
  }
}

function cancelTransaction(cancelTranscation) {
  return (dispatch) => {
    dispatch(request(cancelTranscation));
    transcationEffect.cancelRemittance(cancelTranscation).then(
      (cancelTranscation) => {
        dispatch(success(cancelTranscation));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cancelTranscation) {
    return { type: paymentConstants.GET_TRANSACTION_CANCEL_REQUEST, cancelTranscation };
  }
  function success(cancelTranscation) {
    return { type: paymentConstants.GET_TRANSACTION_CANCEL_SUCCESS, cancelTranscation };
  }
  function failure(error) {
    return { type: paymentConstants.GET_TRANSACTION_CANCEL_FAILURE, error };
  }
}

function getDrawingBank(drawingBank) {
  return (dispatch) => {
    dispatch(request(drawingBank));
    paymentEffect.getDrawingBank(drawingBank).then(
      (drawingBank) => {
        dispatch(success(drawingBank));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(drawingBank) {
    return { type: paymentConstants.GET_DRAWING_BANK_REQUEST, drawingBank };
  }
  function success(drawingBank) {
    return { type: paymentConstants.GET_DRAWING_BANK_SUCCESS, drawingBank };
  }
  function failure(error) {
    return { type: paymentConstants.GET_DRAWING_BANK_FAILURE, error };
  }
}

function clearPreviousMessage() {
  return (dispatch) => {
    dispatch(clearMessage());
  };
  function clearMessage() {
    return { type: commonConstants.CLEAR_PREVIOUS_TRANSFER_MESSAGE, payload: null };
  }
}
